export default __webpack_public_path__ + "static/media/webdev.97021508.png";